import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RequestBodyConverter } from '../RequestBodyConverter';
import { useParams } from 'react-router-dom';
import CurrencyOfferForm from './CurrencyOfferForm';
// import { initialValues  } from './initialValues-testing';
import { showCurrencyOfferApi, updateCurrencyOfferApi, clearEditedCurrencyOffer } from './currencyOfferSlice';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { PICTURE_ATTRIBUTE_NAMES } from '~/config/constants';

function CurrencyOfferUpdate() {
    const { id } = useParams();
    const [resetCount, setResetCount] = useState(0);
    const { editedModel: initialValues } = useSelector((state) => state.shopSaga.currencyOffer);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (rawValues) => {
        let values = new RequestBodyConverter(rawValues);
        values = values.data;
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(updateCurrencyOfferApi({ navigate, values, id }));
    };

    useEffect(() => {
        dispatch(showCurrencyOfferApi({ navigate, id }));

        return () => dispatch(clearEditedCurrencyOffer());
    }, []);

    return (
        <CurrencyOfferForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={PICTURE_ATTRIBUTE_NAMES}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default CurrencyOfferUpdate;
